/* JS for populating swatch images when using color swatches */
const colorRadios = document.querySelectorAll('.variant__input--color-swatch');
const variantData = document.querySelector('[data-variant-json]').innerText;
const variantObj = JSON.parse(variantData);
const colorIndex = parseInt(document.querySelector('[data-color-index]').getAttribute('data-color-index')) || 0;
colorRadios.forEach((color) => {
  const colorValue = color.value;
  const found = variantObj.find((c) => c['option' + (1 + colorIndex)] === colorValue);
  const variantImageSrc = found.featured_media.preview_image.src;
  color.nextSibling.style.backgroundImage = `url('${variantImageSrc}')`;
});
